import { render, staticRenderFns } from "./HostingKvmList.vue?vue&type=template&id=08891f8f&"
import script from "./HostingKvmList.vue?vue&type=script&lang=js&"
export * from "./HostingKvmList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08891f8f')) {
      api.createRecord('08891f8f', component.options)
    } else {
      api.reload('08891f8f', component.options)
    }
    module.hot.accept("./HostingKvmList.vue?vue&type=template&id=08891f8f&", function () {
      api.rerender('08891f8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/kvm/HostingKvmList.vue"
export default component.exports